/**
 * Maps stored tearsheet cashflow scenario `request` JSON into react-hook-form
 * defaults for {@link CashflowModelInputs} CSV export (tearsheet ZIP only).
 * Shallow merge + fee/XIRR fields aligned with CashflowModelInputs loadScenario.
 *
 * @param {unknown} requestRaw
 * @param {string} customerId
 * @returns {Record<string, unknown>}
 */
export function buildCashflowCsvPrefillFromScenarioRequest(requestRaw, customerId) {
  if (requestRaw == null || requestRaw === '') {
    return { customerId };
  }
  const req =
    typeof requestRaw === 'string' ? JSON.parse(requestRaw) : { ...requestRaw };
  if (!req || typeof req !== 'object') {
    return { customerId };
  }
  const out = { ...req, customerId: customerId || req.customerId || '' };

  if (req.isXirrMode != null || req.fee != null || req.xirrPercent != null) {
    out.feeMode = req.isXirrMode ? 'xirr' : 'fee';
    out.feeOrXirrValue = req.isXirrMode
      ? Number(req.xirrPercent ?? 0)
      : Number(req.fee ?? 0);
  }

  return out;
}
